import React from "react";
import { Modal, Button, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { BsPerson, BsCalendar, BsCreditCard2Front } from "react-icons/bs";
import { BsInfoCircle, BsExclamationTriangle } from "react-icons/bs";
import { PutUserAadharConsent } from "../../axios/apis/Users";
import { AppContext } from "../../contexts/AppContext";

function ReAadharAuthenticationModal({ show, onHide, userData, onReAuthenticate }) {
  const { setLoader } = React.useContext(AppContext);
  const handleConfirm = () => {
    setLoader(true);
    PutUserAadharConsent()
      .then(() => {
        setLoader(false);
        onHide();
      })
      .catch((error) => {
        setLoader(false);
        console.log(error);
        onHide();
      });
  };

  const handleReAuthenticateClick = () => {
    setLoader(true);
    PutUserAadharConsent()
      .then(() => {
        setLoader(false);
        onReAuthenticate();
      })
      .catch((error) => {
        setLoader(false);
        console.log(error);
      });
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const d = new Date(dateString);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };
  const fields = [
    {
      label: "Name as per Aadhaar (Auto fetched)",
      value: userData?.nameAsAadhar || "",
      icon: <BsPerson size={22} />,
      required : true
    },
    {
      label: "DOB as per Aadhaar (Auto fetched)",
      value: formatDate(userData?.dobAsAadhar) || "Not Applicable",
      icon: <BsCalendar size={22} />,
      required : true
    },
    {
      label: "Aadhaar ID (Auto-fetched)",
      value: userData?.maskedAadhaar || "",
      icon: <BsCreditCard2Front size={22} />,
      required : true
    },
    {
      label: "Apaar ID",
      value: userData?.apaarByUser || "",
      icon: <BsCreditCard2Front size={22} />,
      tooltip: "If you want to edit your APAAR ID, go to Edit Profile Tile.",
      required : false
    },
  ];

  return (
    <Modal show={show} onHide={onHide} centered size="lg" backdrop="static" keyboard={false}>
      <Modal.Header className="border-bottom-0 pb-0">
        <Modal.Title className="fw-bold fs-5" style={{ color: "#0f4f96" }}>
          Aadhaar Re-authentication
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="px-4 pt-3 pb-2">
        <div className="mb-4">
          {fields.map((field, idx) => (
            <div
              key={idx}
              className="d-flex align-items-center mb-3 gap-3"
            >
              <div
                className="d-flex align-items-center justify-content-center flex-shrink-0 rounded-2"
                style={{
                  width: 48,
                  height: 48,
                  backgroundColor: "#ddeeff",
                  color: "#0f4f96",
                }}
              >
                {field.icon}
              </div>
              <span
                className="fw-semibold text-nowrap d-flex align-items-center gap-1"
                style={{ minWidth: 280, fontSize: "0.9rem" }}
              >
                {field.label}
                {field?.required && <sup className="text-danger">*</sup>} :
                {field.tooltip && (
                  <OverlayTrigger overlay={<Tooltip>{field.tooltip}</Tooltip>}>
                    <span style={{ cursor: "pointer" }}>
                      <BsInfoCircle size={14} color="#0f4f96" />
                    </span>
                  </OverlayTrigger>
                )}
              </span>
              <Form.Control
                type="text"
                value={field.value}
                disabled
                style={{ backgroundColor: "#f0f0f0" }}
              />
            </div>
          ))}
        </div>

        {/* Note 1 */}
        <div
          className="d-flex align-items-start gap-2 rounded-2 p-3 mb-3"
          style={{ border: "1.5px solid #0f4f96", backgroundColor: "#f0f6ff" }}
        >
          <BsInfoCircle size={20} color="#0f4f96" className="flex-shrink-0 mt-1" />
          <div style={{ fontSize: "0.9rem" }}>
            <span className="fw-semibold" style={{ color: "#0f4f96" }}>Note: </span>
            Please verify the Auto-fetched DigiLocker records in your profile. In case your details are not matching OR you had previously skipped verification using the bypass option, please re-authenticate before filling the CAP Application Form.
            Please ignore/close the window if your details are correct.
          </div>
        </div>

        {/* Note 2 */}
        <div
          className="d-flex align-items-center gap-2 rounded-2 p-3"
          style={{ border: "1.5px solid #e6a817", backgroundColor: "#fff8e8" }}
        >
          <BsExclamationTriangle size={20} color="#e6a817" className="flex-shrink-0" />
          <div style={{ fontSize: "0.9rem" }}>
            <span className="fw-semibold" style={{ color: "#e6a817" }}>Note 2: </span>
            Only one-time Aadhaar Re-authentication is allowed.
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="border-top-0 pt-2">
        <Button
          variant="outline-primary"
          style={{
            "--bs-btn-color": "#0f4f96",
            "--bs-btn-border-color": "#0f4f96",
            "--bs-btn-hover-bg": "transparent",
            "--bs-btn-hover-border-color": "#0f4f96",
            "--bs-btn-hover-color": "#0f4f96",
            "--bs-btn-active-bg": "transparent",
            "--bs-btn-active-border-color": "#0f4f96",
            "--bs-btn-active-color": "#0f4f96",
            minWidth: 220,
          }}
          onClick={handleReAuthenticateClick}
        >
          No, I want to Re-authenticate.
        </Button>
        <Button
          variant="primary"
          style={{ backgroundColor: "#0f4f96", borderColor: "#0f4f96", minWidth: 220 }}
          onClick={handleConfirm}
        >
          Yes, My details are correct.
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ReAadharAuthenticationModal;
